import { LocalMediaStorageKeys } from '../constants';
export const setVideoState = (hasVideo) => (dispatch) => {
    dispatch({ type: 'LOCAL_MEDIA/SET_VIDEO_STATE', payload: hasVideo });
};
export const setAudioState = (hasAudio) => (dispatch) => {
    dispatch({ type: 'LOCAL_MEDIA/SET_AUDIO_STATE', payload: hasAudio });
};
export const setMediaState = (mediaState) => (dispatch) => {
    dispatch({ type: 'LOCAL_MEDIA/SET_MEDIA_STATE', payload: mediaState });
    if (typeof mediaState.hasAudio === 'boolean') {
        sessionStorage.setItem(LocalMediaStorageKeys.HasAudio, `${mediaState.hasAudio}`);
    }
    if (typeof mediaState.hasVideo === 'boolean') {
        sessionStorage.setItem(LocalMediaStorageKeys.HasVideo, `${mediaState.hasVideo}`);
    }
};
